import { IItem } from '@admin/types/item';

/**
 * Normalizes Angular fields (snake_case) to GraphQL format (camelCase) for IItem
 * This ensures compatibility between legacy Angular components and new React/GraphQL components
 */
export const normalizeItemToGraphQL = (item: IItem): IItem => {
  return {
    ...item,
    // Basic fields
    accountID: item.accountID || item.account_id,
    palletId: item.palletId || item.pallet_id,
    warehouseId: item.warehouseId || item.warehouse_id,
    groupId: item.groupId || item.group_id,
    latestOpenIncidentKind: item.latestOpenIncidentKind || item.latest_open_incident_kind,
    customCategoryName: item.customCategoryName || item.custom_category_name,
    sizingSelection: item.sizingSelection || item.sizing_selection,
    dimensionsOverwritten: item.dimensionsOverwritten ?? item.dimensions_overwritten ?? false,
    numMovers: item.numMovers ?? item.num_movers,
    // Complex fields
    packaging: item.packaging
      ? {
          ...item.packaging,
          materialCategoryId: item.packaging.materialCategoryId || item.packaging.material_category_id,
          partCategoryId: item.packaging.partCategoryId || item.packaging.part_category_id,
        }
      : undefined,
  };
};

/**
 * Creates an updated item with both Angular and GraphQL field formats for backward compatibility
 */
export const createUpdatedItemWithBothFormats = (originalItem: IItem, updates: Partial<IItem>): IItem => {
  return {
    ...originalItem,
    ...updates,
    // Ensure both formats are available
    ...(updates.sizingSelection !== undefined && {
      sizing_selection: updates.sizingSelection,
    }),
    ...(updates.customCategoryName !== undefined && {
      custom_category_name: updates.customCategoryName,
    }),
    ...(updates.dimensionsOverwritten !== undefined && {
      dimensions_overwritten: updates.dimensionsOverwritten,
    }),
    ...(updates.numMovers !== undefined && {
      num_movers: updates.numMovers,
    }),
  };
};
